export default ({ request }) => ({
    orderProofingListApi(data = {}) {
        return request({
            url: '/factory/order/proofing/list',
            method: 'post',
            data,
        })
    },
    orderProofingDetailApi(data = {}) {
        return request({
            url: '/factory/order/proofing/detail',
            method: 'post',
            data,
        })
    },
    orderProofingAddSaveApi(data = {}) {
        return request({
            url: '/factory/order/proofing/add/save',
            method: 'post',
            data,
        })
    },
    orderProofingEditSaveApi(data = {}) {
        return request({
            url: '/factory/order/proofing/edit/save',
            method: 'post',
            data,
        })
    },
    orderProofingDelApi(data = {}) {
        return request({
            url: '/factory/order/proofing/del',
            method: 'post',
            data,
        })
    },
    orderProofingGoodsListApi(data = {}) {
        return request({
            url: '/factory/order/proofing/goods/list',
            method: 'post',
            data,
        })
    },
    orderProofingGoodsDelApi(data = {}) {
        return request({
            url: '/factory/order/proofing/goods/del',
            method: 'post',
            data,
        })
    },
    orderProofingGoodsSaveApi(data = {}) {
        return request({
            url: '/factory/order/proofing/goods/save',
            method: 'post',
            data,
        })
    },
    orderProofingGoodsEditApi(data = {}) {
        return request({
            url: '/factory/order/proofing/goods/edit',
            method: 'post',
            data,
        })
    },

})
